import { render, staticRenderFns } from "./uiVideoPlayer.vue?vue&type=template&id=c4f68008"
import script from "./uiVideoPlayer.vue?vue&type=script&lang=js"
export * from "./uiVideoPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports